export default __webpack_public_path__ + "3fd4dbb3e46f5349f18ecebd564b598f.svg";